import type { Config } from '~/config'
import { m } from '~/paraglide/messages'

export type FinalRewardPreviewSlide =
  | { kind: 'compare'; titleSuffix: () => string }
  | { kind: 'image'; src: string; titleSuffix: () => string }

type SlideConfig = Pick<
  Config,
  | 'free_final_reward_preview_slide_2_img_url'
  | 'free_final_reward_preview_slide_3_img_url'
  | 'paid_final_reward_preview_slide_2_img_url'
  | 'paid_final_reward_preview_slide_3_img_url'
>

/**
 * The final reward preview's banner slides (GLOSSARY.md "Final reward
 * preview"): the compare, then the focusing and home previews, with Shop's
 * detail-slide suffix copy (not its order). The suffix belongs to the config
 * key, so a missing or empty URL drops its slide without handing its suffix
 * on.
 */
export function getFinalRewardPreviewSlides(
  config: SlideConfig,
  reward: 'free' | 'paid',
): FinalRewardPreviewSlide[] {
  const images = [
    {
      src: config[`${reward}_final_reward_preview_slide_2_img_url`],
      titleSuffix: m.shop_land_title_showcase_focusing,
    },
    {
      src: config[`${reward}_final_reward_preview_slide_3_img_url`],
      titleSuffix: m.shop_land_title_showcase_home,
    },
  ]
  return [
    { kind: 'compare', titleSuffix: m.shop_land_title_showcase_forest },
    ...images.flatMap(({ src, titleSuffix }) =>
      src ? [{ kind: 'image' as const, src, titleSuffix }] : [],
    ),
  ]
}

/**
 * An empty title (a native catalog miss) takes no suffix: a lone " · Home"
 * names nothing.
 */
export function withTitleSuffix(title: string, suffix: string): string {
  return title ? `${title}${suffix}` : ''
}
